<!-- 基本信息 -->
<template>
    <div class="container">
      <div class="vue">
        <div class="header   flex flexColumn">
          <div class="head-title borderB">
            <div class="text">今日管理</div>
          </div>
          <div class="headSearch">
            <div class="headSearch-left Fs14" style="width: 100%;">
              <div class="form-data group">
                <span>上报人员：</span>
                <el-input v-model="SearchForm.name" style="width: 150px;" size="mini" placeholder="" clearable></el-input>
              </div>
              <div class="form-data group">
                <span>上报时间：</span>
                <el-date-picker v-model="SearchForm.createTime" style="width: 150px;" size="mini" type="date" placeholder="选择日期" clearable></el-date-picker>
              </div>
              <div class="form-data group" style="padding-left: 20px;">
                <span>是否指导：</span>
                <el-select v-model="SearchForm.hasReply" style="width: 100px;" filterable placeholder="请选择" clearable>
                  <el-option v-for="item in hasReplyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="form-data group">
                <el-button @click="SearchBut" round type="primary" size="mini">搜索</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="content" style="padding-top: 20px;">
          <el-table
            :header-cell-style="{ background: '#f5f5f5' }"
            :data="recordList.list"
            style="width: 100%">
            <el-table-column prop="id" label="#" min-width="1"> </el-table-column>
            <el-table-column prop="createTime" label="上传日期" min-width="2">
              <template slot-scope="scope">
                <span :style="{'color': scope.row.isToday ? 'red': 'black'}">{{ scope.row.createTime | filterTime(1) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" min-width="1"> </el-table-column>
            <el-table-column prop="tel" label="账号" min-width="2"> </el-table-column>
            <el-table-column prop="uTel" label="手机号" min-width="2"> </el-table-column>
            <el-table-column prop="sex" label="性别" min-width="1">
              <template slot-scope="scope">
                <span>{{ scope.row.sex | filterSex }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="age" label="年龄" min-width="1">
              <template slot-scope="scope">
                <span>{{ scope.row.birth | calculateAge }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="birth" label="出生日期" min-width="3">
              <template slot-scope="scope">
                <span>{{ scope.row.birth | filterTime(1) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="serviceItem" label="服务项目" min-width="3"></el-table-column>
            <el-table-column prop="hasReply" label="是否已回复" min-width="1">
              <template slot-scope="scope">
                <span>{{ scope.row.hasReply | filterHasVisit }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="2">
              <template slot-scope="scope">
                <el-button @click="recordUpdateBut(scope.row)" type="primary" size="small">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="Pagination flex">
            <div class="text">
              <span>共{{ recordList.total }}条记录，</span>
              <span class="pageNum">{{ recordList.pageNum }}</span>
              <span>/{{ recordList.pages }}页</span>
            </div>
            <el-pagination
              v-if="recordList !== ''"
              @current-change="handleCurrentChange"
              :current-page.sync="recordList.pageNum"
              :page-size="recordList.pageSize"
              layout="prev, pager, next, jumper"
              :total="recordList.total">
            </el-pagination>
          </div>
        </div>
      </div>
  
    <!-- 表单详情 -->
    <el-dialog title="管理详情" width="800px" :visible.sync="recordDialogVisible" :append-to-body="true" :close-on-click-modal="false">
      <div>
        <el-tabs v-model="tabActiveName" type="card" @tab-click="handleClick">
          <el-tab-pane label="上传记录" name="first">
            <el-collapse v-model="activeNames" @change="handleChange">
              <el-collapse-item name="1">
                <template slot="title">
                  饮食记录 <i class="header-icon el-icon-info" v-if="list1.length > 0"></i>
                </template>
                <div v-for="item in list1" style="color: chocolate;">
                  <span>【{{ item.createTime | filterTime(2)}}】：</span>
                  <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                  <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title">
                  运动记录 <i class="header-icon el-icon-info" v-if="list2.length > 0"></i>
                </template>
                <div v-for="item in list2" style="color: chocolate;">
                  <span>【{{ item.createTime | filterTime(2)}}】：</span>
                  <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                  <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                </div>
              </el-collapse-item>
              <el-collapse-item name="3">
                <template slot="title">
                  二便记录 <i class="header-icon el-icon-info" v-if="list3.length > 0"></i>
                </template>
                <div v-for="item in list3" style="color: chocolate;">
                  <span>【{{ item.createTime | filterTime(2)}}】：</span>
                  <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                  <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                </div>
              </el-collapse-item>
              <el-collapse-item name="4">
                <template slot="title">
                  睡眠记录 <i class="header-icon el-icon-info" v-if="list4.length > 0"></i>
                </template>
                <div v-for="item in list4" style="color: chocolate;">
                  <span>【{{ item.createTime | filterTime(2)}}】：</span>
                  <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                  <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                </div>
              </el-collapse-item>
              <el-collapse-item name="5">
                <template slot="title">
                  用药记录 <i class="header-icon el-icon-info" v-if="list5.length > 0"></i>
                </template>
                <div v-for="item in list5" style="color: chocolate;">
                  <span>【{{ item.createTime | filterTime(2)}}】：</span>
                  <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                  <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                </div>
              </el-collapse-item>
              <el-collapse-item name="6">
                <template slot="title">
                  身况记录 <i class="header-icon el-icon-info" v-if="list6.length > 0"></i>
                </template>
                <div v-for="item in list6" style="color: chocolate;">
                  <span>【{{ item.createTime | filterTime(2)}}】：</span>
                  <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                  <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                </div>
              </el-collapse-item>
              <el-collapse-item name="7">
                <template slot="title">
                  舌象记录 <i class="header-icon el-icon-info" v-if="list7.length > 0"></i>
                </template>
                <div v-for="item in list7" style="color: chocolate;">
                  <span>【{{ item.createTime | filterTime(2)}}】：</span>
                  <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                  <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                </div>
              </el-collapse-item>
              <el-collapse-item name="8">
                <template slot="title">
                  面相记录 <i class="header-icon el-icon-info" v-if="list8.length > 0"></i>
                </template>
                <div v-for="item in list8" style="color: chocolate;">
                  <span>【{{ item.createTime | filterTime(2)}}】：</span>
                  <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                  <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                </div>
              </el-collapse-item>
              <el-collapse-item name="9">
                <template slot="title">
                  身高记录 <i class="header-icon el-icon-info" v-if="list9.length > 0"></i>
                </template>
                <div v-for="item in list9" style="color: chocolate;">
                  <span>【{{ item.createTime | filterTime(2)}}】：</span>
                  <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                  <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                </div>
              </el-collapse-item>
              <el-collapse-item name="10">
                <template slot="title">
                  体重记录 <i class="header-icon el-icon-info" v-if="list10.length > 0"></i>
                </template>
                <div v-for="item in list10" style="color: chocolate;">
                  <span>【{{ item.createTime | filterTime(2)}}】：</span>
                  <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                  <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                </div>
              </el-collapse-item>
            </el-collapse>
            <el-form ref="recordForm" :model="recordForm" :rules="rules" label-width="80px" style="margin-top: 30px;">
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="24">
                  <el-form-item label="专家指导" prop="note">
                    <el-input v-model="recordForm.note" type="textarea" :rows="5" placeholder="" style="width: 100%;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="体检记录" name="second">
            <div style="width: 100%;">
              <el-input v-model="logItemContent" :readonly="true" type="textarea" :rows="20" placeholder="" style="width: 100%;"></el-input>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="recordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="recordUpdateClick">确 定</el-button>
      </div>
    </el-dialog>
  
    </div>
  </template>
  
  <script>
  import { apiGetTodayRecord, apiGetTodayRecordPage, apiAddTodayRecord, apiUpdateTodayRecord, apiDeleteTodayRecord,
    apiGetTodayLog } from '@/api/clientManage'
import { apiGetJkytLog } from '@/api/alertManage'
  let _self
  export default {
    name: '',
    props: [''],
    data() {
      return {
        recordList: '', // 记录列表page
        SearchForm: {
          name: '',
          createTime: '',
          hasReply: '',
        },
        pages: {
          page: 1, // 页数
          size: 20
        },
        hasReplyOptions: [
          {label: '否', value: 1},
          {label: '是', value: 2},
        ],
        // 验证
        rules: {
          note: [
            { required: true, message: '请输入专家指导', trigger: 'blur' },
          ],
        },
        // 记录
        recordForm: {},
        recordDialogVisible: false,
        tabActiveName: 'first',
        activeNames: ['1'],
        list1: [],
        list2: [],
        list3: [],
        list4: [],
        list5: [],
        list6: [],
        list7: [],
        list8: [],
        list9: [],
        list10: [],
        logItemContent: '',
      }
    },
  
    components: {  },
  
    computed: {},
  
    beforeMount() {},
  
    mounted() {
      _self = this
      this.GetRecordList();
    },
  
    methods: {
      // 搜索
      SearchBut() {
        this.GetRecordList();
      },
      // 分页
      handleCurrentChange(val) {
        this.pages.page = val
        console.log(`当前页: ${val}`)
        this.GetRecordList()
      },
      handleChange() {

      },
      // 接口
      // 获取基本用户的列表
      GetRecordList() {
        let createTimeLong = 0;
        if(this.SearchForm.createTime) {
          createTimeLong = this.SearchForm.createTime.getTime();
        }
        apiGetTodayRecordPage({
          name: this.SearchForm.name,
          createTimeLong: createTimeLong,
          hasReply: this.SearchForm.hasReply,
          page: this.pages.page,
          pageSize: this.pages.size
        }).then(res => {
          if (res.status === 0) {
            this.recordList = res.data
            this.recordList.list.forEach(r => {
              r.isToday = this.isToday(r.createTime);
            });
          }
        })
      },
      // 记录信息
      recordUpdateBut(row) {
        this.recordDialogVisible = true;
        this.list1 = [],
        this.list2 = [],
        this.list3 = [],
        this.list4 = [],
        this.list5 = [],
        this.list6 = [],
        this.list7 = [],
        this.list8 = [],
        this.list9 = [],
        this.list10 = [],
        apiGetTodayRecord({
          id: row.id
        }).then(res => {
          if (res.status === 0) {
            this.recordForm = res.data;
          }
        })
        apiGetTodayLog({
          rid: row.id
        }).then(res => {
          if (res.status === 0) {
            let logs = res.data;
            logs.forEach( log => {
              if(log.type == 1) {
                this.list1.push(log);
              } else if(log.type == 2) {
                this.list2.push(log);
              } else if(log.type == 3) {
                this.list3.push(log);
              } else if(log.type == 4) {
                this.list4.push(log);
              } else if(log.type == 5) {
                this.list5.push(log);
              } else if(log.type == 6) {
                this.list6.push(log);
              } else if(log.type == 7) {
                this.list7.push(log);
              } else if(log.type == 8) {
                this.list8.push(log);
              } else if(log.type == 9) {
                this.list9.push(log);
              } else if(log.type == 10) {
                this.list10.push(log);
              }
            });
          }
        })
        this.logItemContent = "";
        apiGetJkytLog({uid: row.uid, createTimeLong: row.createTime}).then(res => {
          if(res.status == 0) {
            this.logItemContent = res.data.content;
          }
        });
      },
      recordUpdateClick() {
        this.$refs['recordForm'].validate(valid => {
          if (valid) {
            apiUpdateTodayRecord({
              id: this.recordForm.id,
              note: this.recordForm.note,
            }).then(res => {
              if (res.status === 0) {
                this.$message({message: '保存成功', type: 'success'});
                this.recordDialogVisible = false;
                this.recordForm = {};
                this.GetRecordList();
              } else {
                this.$message({message: '保存失败', type: 'error'});
              }
            });
          }
        });
      },
      // 是否当天
      isToday(date) {
          var d0 = new Date();
          var y0 = d0.getFullYear(); 
          var m0 = d0.getMonth() + 1; 
          var d0 = d0.getDate(); 
          var d1 = new Date(date);
          var y1 = d1.getFullYear(); 
          var m1 = d1.getMonth() + 1; 
          var d1 = d1.getDate(); 
          return y0==y1 && m0==m1 && d0==d1;
      },
      handleClick(){

      },
    },
    watch: {}
  }
  </script>
  <style lang="scss" scoped>
  .flex {
    display: flex;
  }
  .FZ0875 {
    font-size: 0.875em;
  }
  .textalignLeft {
    text-align: left;
  }
  .vue {
    padding: 0 10px;
    background-color: #fff;
    border-left: 2px solid #119685;
    .header {
      height: 92px;
      .headSearch {
        .headSearch-left {
          width: 85%;
          float: left;
          .form-data {
            // span {
            //   width: 90px;
            // }
            /deep/ .el-date-editor,
            .el-input,
            .el-cascader {
              width: 200px;
            }
          }
        }
        .headSearch-right {
          width: 10%;
          float: right;
        }
      }
      .text {
        text-align: left;
        // font-size: 0.875em;
        color: #119685;
        padding: 10px 5px;
      }
    }
    .content {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: calc(100vh - 214px);
      /deep/ .el-table {
        overflow: auto;
        height: calc(100vh - 272px);
      }
      /deep/ .el-table .warning-row {
        background: oldlace;
      }
  
      /deep/ .el-table .success-row {
        background: #f0f9eb;
      }
      .Pagination {
        justify-content: space-between;
        padding: 10px 20px;
        align-items: center;
        font-size: 0.875em;
        color: #7b7b7b;
        .text {
          .pageNum {
            color: #119685;
          }
        }
      }
    }
  }
  .dialog {
  }
  </style>
  